// extracted by mini-css-extract-plugin
export default {"loader":"loader--qjTcr","lds-ring":"lds-ring--j1YMT"};